<template>
  <div id="Patent">
    <div class="patentContainer">
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于参数空间投票和贝塞尔拟合的快速车道线检测方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL202010243134.1</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">融合统计显著性的高分辨率SAR影像车辆目标检测方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL202010474473.0</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">基于结构性的高分辨率单极化SAR影像建筑目标检测方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL202010475576.4</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于多种先验信息约束的卫星视频目标智能检测方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL202010680785.7</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于多尺度残差网络模型的高分影像建筑物提取方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL202110434612.1</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于先验矢量引导的高分影像建筑物提取精处理方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL202110443616.6</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于阴影的高分辨率遥感影像建筑物高度估测方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201810271738.X</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于无人机视频的震后建筑物损毁检测方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201911249407.7</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于图像锐化的时序数据耕地提取方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL202110421926.8</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于图卷神经网络的遥感影像小水体提取方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL202110364971.4</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于遥感影像的OpenStreetMap路网数据质量评价方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201911022565.9</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种顾及建筑物三维及边缘形状特征的无人机影像分割方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201810680919.8</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种卫星视频小目标实时跟踪方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201811235772.8</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于视觉的四旋翼无人机自主飞行系统</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL202120766059.7</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于矢量路网融合与遥感影像验证的道路网更新方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201811074936.3</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于视觉的车辆检测跟踪预警方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201810680919.8</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于视觉的车道线检测方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201810886340.7</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">多特征多层次景象匹配的飞行器自主导航方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL202010111370.8</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">基于随机森林的多尺度分层采样的高分卫星影像变化检测方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201810214301.2</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种基于自适应聚类学习的道路网提取的方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201610273017.3</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">静止轨道卫星序列遥感影像海岛礁区域自动几何校正方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201810179469.4</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种软硬件一体的便携式遥感影像实时处理系统</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL201710597914.4</span>
        </div>
      </div>
      <el-divider></el-divider>
      
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">导航数据辅助下的遥感影像道路网自动提取方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL 2016 1 1153399.2</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种软硬件一体的便携式遥感影像实时处理系统</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；马国锐；端海旺</span>
              <br /> -->
          <span>专利号：ZL 2017 1 0597914.4</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >基于随机森林的多尺度分层采样的高分卫星影像变化检测方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：孙开敏；白婷；李文卓；<b>眭海刚</b></span>
              <br /> -->
          <span>专利号：ZL 2018 1 0214301.2</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >静止轨道卫星序列遥感影像海岛礁区域自动几何校正方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；付宏博</span>
              <br /> -->
          <span>专利号：ZL 2018 1 0179469.4</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种基于自适应聚类学习的道路网提取的方法方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL 2016 1 0273017.3</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种结构线束统计匹配的高分遥感影像道路提取方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL 2016 1 0272080.5</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种基于面向对象的特定区域全自动变化监测方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：孙开敏；覃星力；李鹏飞；<b>眭海刚</b></span>
              <br /> -->
          <span>专利号：ZL 2017 1 0211968.2</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种基于水平集分割极化SAR影像的水体精确提取方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；安凯强；徐川；刘俊怡</span>
              <br /> -->
          <span>专利号：ZL 2016 1 1034125.1</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">用于大观测角传感器的交叉辐射定标方法及系统</span>
        <div class="font-name">
          <!-- <span>发明人：孙开敏；陈业培；白婷；<b>眭海刚</b></span>
              <br /> -->
          <span>专利号：ZL 2017 1 0349402.6</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >导航数据辅助下的高分辨率光学影像损毁道路提取方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；董亮；蔡肖芋；刘飞</span>
              <br /> -->
          <span>专利号：ZL 2016 1 0580440.8</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种基于结构指数特征的遥感影像道路交叉口提取的方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL 2016 1 0273785.9</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种异构感知数据的动态适配接入方法</span>
        <div class="font-name">
          <!-- <span
                >发明人：卜方玲；王智莉；马静；徐兆卓；<b>眭海刚</b>；徐新</span
              >
              <br /> -->
          <span>专利号：ZL 2015 1 0162915.7</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种航空遥感影像的建筑物轮廓线提取方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；涂继辉；冯文卿；刘飞；孙开敏</span>
              <br /> -->
          <span>专利号：ZL 2016 1 0527323.5</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >基于多特征综合及机器学习的高分卫星影像云检测方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：孙开敏；白婷；邓实权；陈业培；<b>眭海刚</b></span>
              <br /> -->
          <span>专利号：ZL 2016 1 0132801.2</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种基于结构指数特征的遥感影像道路交叉口提取的方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL 2016 1 0273785.9</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >非重叠视域跨摄像机室内行人目标跟踪方法及系统</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；吕枘蓬；涂继辉；董亮；蔡肖芋</span>
              <br /> -->
          <span>专利号：ZL 2015 1 0063819.7</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种顾及辐射二维分布的影像间的匀光匀色方法及系统</span
        >
        <div class="font-name">
          <!-- <span>发明人：孙开敏；李文卓；李鹏飞；<b>眭海刚</b></span>
              <br /> -->
          <span>专利号：ZL 2016 1 0111326.0</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >地理信息时空约束下的无人机运动目标跟踪与定位方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；吕枘蓬；涂继辉；蔡肖芋</span>
              <br /> -->
          <span>专利号：ZL 2015 1 0706222.X</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种基于北斗/GPS定位、RFID和摄像头获取学生精准考勤状态的方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；金瑶</span>
              <br /> -->
          <span>专利号：ZL 2016 1 0109304.0</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >多机多任务并行卫星遥感影像正射校正处理系统及其方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：徐丰；孙开敏；<b>眭海刚</b>；范一大</span>
              <br /> -->
          <span>专利号：ZL 2015 1 0587785.1</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种基于阴影和文理特征的航空建筑物损毁检测方法</span
        >
        <div class="font-name">
          <!-- <span
                >发明人：<b>眭海刚</b>；涂继辉；吕枘蓬；冯文卿；马国锐；孙开敏</span
              >
              <br /> -->
          <span>专利号：ZL 2016 1 0097760.8</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种基于多层次策略的光学与SAR影像高精度配准方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；徐川；华风；安凯强</span>
              <br /> -->
          <span>专利号：ZL 2015 1 0628655.8</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种倾斜航空影像中建筑物立面损毁检测的方法和装置</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；涂继辉；贾曲；吕枘蓬；马国锐</span>
              <br /> -->
          <span>专利号：ZL 2015 1 0494876.0</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种无人机多重叠遥感影像的建筑轮廓线提取方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；涂继辉；贾曲；宋志娜；陈光；徐川</span>
              <br /> -->
          <span>专利号：ZL 2015 1 0025503.9</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种遥感影像圆形油罐自动检测方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；蔡肖芋</span>
              <br /> -->
          <span>专利号：ZL 2014 1 0424506.5</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >先验地理信息辅助下的光学遥感影像舰船检测方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；宋志娜；付琬洁；王煜杰</span>
              <br /> -->
          <span>专利号：ZL 2014 1 0086835.3</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种无人机遥感影像建筑物三维损毁检测方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；涂继辉；宋志娜；马国锐；刘俊怡</span>
              <br /> -->
          <span>专利号：ZL 2014 1 0352371.6</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">基于矢量数据的SAR影像道路损毁信息提取方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；吴弦骏；刘俊怡；范一大；陈光</span>
              <br /> -->
          <span>专利号：ZL 2013 1 0750917.9</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一体化的光学遥感影像与GIS自动配准与水体提取方法</span
        >
        <div class="font-name">
          <!-- <span
                >发明人：<b>眭海刚</b>；陈光；徐川；涂继辉；刘俊怡；马国锐；孙开敏</span
              >
              <br /> -->
          <span>专利号：ZL 2013 1 0359358.9</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种基于结构指数特征的遥感影像道路交叉口提取的方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；陈光；冯文卿；程效猛；涂继辉</span>
              <br /> -->
          <span>专利号：ZL 2016 1 0273785.9</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种异源遥感影像配准方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；华凤；徐川；刘俊怡</span>
              <br /> -->
          <span>专利号：ZL 2013 1 0478383.9</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >三维GIS辅助下的高分遥感影像建筑物倒损检测方法</span
        >
        <div class="font-name">
          <!-- <span
                >发明人：<b>眭海刚</b>；李欣；范一大；孙开敏；刘俊怡；涂继辉</span
              >
              <br /> -->
          <span>专利号：ZL 2014 1 0018436.3</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种基于多尺度分割和SIFT的可见光与红外图像配准的方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；马国锐；孙开敏；刘俊怡；薛新春</span>
              <br /> -->
          <span>专利号：ZL 2013 1 0271314.0</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >多层次多特征约束下的光学和SAR影像自动配准方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；徐川；刘俊怡；华凤</span>
              <br /> -->
          <span>专利号：ZL 2013 1 0307335.3</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">抗字幕干扰的图像无缝自动拼接方法</span>
        <div class="font-name">
          <!-- <span>发明人：刘进；<b>眭海刚</b>；马国锐；刘俊怡</span>
              <br /> -->
          <span>专利号：ZL 2012 1 0533814.2</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >基于Gist特征学习的复杂海面遥感影像舰船检测方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；王煜杰；孙开敏；陈光</span>
              <br /> -->
          <span>专利号：ZL 2012 1 0339791.1</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种光学影像和SAR影像一体化分割配准方法</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；徐川；刘俊怡；华凤</span>
              <br /> -->
          <span>专利号：ZL 2012 1 0369264.5</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >基于光谱特性和拓扑关系的城市遥感影像阴影检测方法</span
        >
        <div class="font-name">
          <!-- <span
                >发明人：孙开敏；<b>眭海刚</b>；张宏雅；李文卓；刘俊怡；马国锐</span
              >
              <br /> -->
          <span>专利号：ZL 2012 1 0283344.9</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >一种基于阴影区域内外检查线匹配的阴影消除方法</span
        >
        <div class="font-name">
          <!-- <span
                >发明人：孙开敏；<b>眭海刚</b>；李文卓；张宏雅；刘俊怡；马国锐</span
              >
              <br /> -->
          <span>专利号：ZL 2012 1 0342195.9</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">一种SAR图像道路提取方法</span>
        <div class="font-name">
          <!-- <span>发明人：刘俊怡；<b>眭海刚</b>；马国锐；孙开敏</span>
              <br /> -->
          <span>专利号：ZL 2012 1 0261328.X</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">小型无人机低功耗定位识别装置</span>
        <div class="font-name">
          <!-- <span>发明人：<b>眭海刚</b>；雷俊锋；孙开敏；马国锐；刘俊怡</span>
              <br /> -->
          <span>专利号：ZL 2013 2 0294396.6</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title">基于凸面模型的遥感影像对象级变化检测方法</span>
        <div class="font-name">
          <!-- <span>发明人：孙开敏；<b>眭海刚</b>；马国锐；刘俊怡；肖志峰</span>
              <br /> -->
          <span>专利号：ZL 2009 1 0063299.4</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="font-name">发明名称：</span>
        <span class="font-title"
        >基于形式概念分析的遥感信息处理服务分类本体构建方法</span
        >
        <div class="font-name">
          <!-- <span>发明人：詹勤；<b>眭海刚</b>；张霞；冯媛媛</span>
              <br /> -->
          <span>专利号：ZL 2009 1 0272459.6</span>
        </div>
      </div>
      <el-divider></el-divider>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang='less' scoped>
#Patent {
  margin-top: 20px;
  color: #454545;
  font-size: 14px;
  line-height: 24px;
  .patentContainer{
    height: 600px;
    overflow-y: scroll;
  }
  .patentContainer::-webkit-scrollbar {
    width: 6px;
  }
  .patentContainer::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(208, 208, 208, 0.4);
  }
  .font-title {
    // font-family: "Times New Roman", Times, serif;
    font-weight: bold;
  }
   .font-name {
     // font-family: "Times New Roman", Times, serif;
   }
}
</style>
